import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { FC } from 'react';
import { Page } from '~/components/ui/page';
import { Title } from '~/components/ui/typography';

export const LoadingScreen: FC<Props> = ({ message }) => {
  return (
    <Page>
      <Box mt={7} mb={9}>
        <Title>{message}</Title>
        <Box my={7}>
          <CircularProgress color="primary" size={'60px'} />
        </Box>
      </Box>
    </Page>
  );
};

export interface Props {
  message: string;
}
